module.exports = __webpack_public_path__ + "img/circlemarkersel.ddb8b8cc.gif";